import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import http from './services/http';
import router from './router';
import store from './store';
import filters from './filters';

import Buefy from 'buefy';
import VueClipboard from 'vue-clipboard2';

import VueGtag from 'vue-gtag';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faVideo,
  faTag,
  faCaretUp,
  faCaretDown,
  faPlus,
  faPlay,
  faStepForward,
  faStepBackward,
  faStop,
  faCog,
  faCheck,
  faStopwatch,
  faList,
  faLayerGroup,
  faEllipsisH,
  faClock,
  faTrash,
  faExclamationCircle,
  faStream,
  faSquare,
  faCheckSquare,
  faTint,
  faShare,
  faClone,
  faColumns,
  faArrowRight,
  faLink,
  faCopy,
  faSpinner,
  faSave,
  faExclamationTriangle,
  faFileExport,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faVideo,
  faTag,
  faCaretUp,
  faCaretDown,
  faPlus,
  faPlay,
  faStepForward,
  faStepBackward,
  faStop,
  faCog,
  faCheck,
  faStopwatch,
  faList,
  faLayerGroup,
  faEllipsisH,
  faClock,
  faTrash,
  faExclamationCircle,
  faStream,
  faSquare,
  faCheckSquare,
  faTint,
  faShare,
  faClone,
  faColumns,
  faArrowRight,
  faLink,
  faCopy,
  faSpinner,
  faSave,
  faExclamationTriangle,
  faFileExport
);

Vue.component('vue-fontawesome', FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.use(http);
Vue.use(filters);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_GTM_KEY) {
  Vue.use(
    VueGtag,
    {
      config: {
        id: process.env.VUE_APP_GTM_KEY,
        params: {
          anonymize_ip: true,
        },
      },
    },
    router
  );
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
